import React, { useState } from 'react';
import { getCampaignCalender } from 'gqlQueries/commonQueries';
import { useLazyQuery } from '@apollo/client';
import _ from 'lodash';
import { customDatesParser } from 'parser/general/customDatesParser';
const errorMessage: string = 'Something went wrong!';

function useGetCampaignCalender() {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<null | string>(null);

    const [getCalendar] = useLazyQuery(getCampaignCalender, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    function onFetchComplete(payload: any) {
        try {
            const { getCustomCalendar } = payload;
            const getStartDates = customDatesParser(getCustomCalendar);
            setData(getStartDates);
        } catch (error: any) {
            console.error(error);
            setError(error);
        } finally {
            setLoading(false);
        }
    }

    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        data,
        loading,
        getCampaignCalenderCall: (variables: any) => {
            setLoading(true);
            getCalendar(variables);
        },
        error,
    };
}

export default useGetCampaignCalender;
